function AutofocusDirective($timeout) {
  return {
    link(scope, element, attrs) {
      scope.$watch(attrs.autofocus, (newVal) => {
        if (newVal) {
          $timeout(() => {
            element[0].focus();
          }, 0);
        }
      });
    }
  };
}

AutofocusDirective.$inject = ['$timeout'];

export default AutofocusDirective;
